import { ref, useContext, useRouter } from '@nuxtjs/composition-api';

const useFetchProducts = (category: any) => {
  const {
    $api: { productsService },
  } = useContext();
  const router = useRouter();
  const loading = ref(false);
  const products = ref([]);
  const meta = ref({});

  const fetchProducts = async ({
    categories,
    page,
    sortedBy,
  }: {
    categories: any;
    page: any;
    sortedBy: any;
  }) => {
    try {
      loading.value = true;
      router.push({
        query: {
          categories:
            categories &&
            (categories.length ? categories.join(',') : undefined),
          page,
          sortedBy,
        },
      });

      const categoriesFilter = [
        !categories || !categories.length ? category.value.id : [...categories],
      ];

      const { data: fetchedProducts, meta: productsMeta } =
        await productsService.getAllProducts({
          page,
          search: `categories.category_id:${categoriesFilter.join(',')}`,
          searchFields: 'categories.category_id:in',
          orderBy: 'name' as any,
        });
      products.value = fetchedProducts as any;
      meta.value = productsMeta;
    } catch (error) {
    } finally {
      loading.value = false;
    }
  };

  // To remove after frontkit will be integrated
  const fetchProductsByIds = async (
    productIds: (string | number)[],
    params: any = {},
  ): Promise<any[] | undefined> => {
    try {
      const response = await productsService.getAllProducts({
        ...params,
        ...{
          search: `id:${productIds.map((id) => `${id}`).join(',')}`,
          searchFields: 'id:in',
          limit: 0,
        },
      });

      return response?.data;
    } catch (e) {
      console.error('Fetch products failed: ', e);
      return undefined;
    }
  };

  return {
    loading,
    products,
    meta,
    fetchProducts,
    fetchProductsByIds,
  };
};

export default useFetchProducts;
